import React, { useContext, useState } from "react";
import { TextField, Grid, Button, Box, Typography, Checkbox, MenuItem, IconButton, Dialog, DialogContent, DialogTitle, DialogActions, FormGroup, FormControlLabel } from "@mui/material";
import { Add, Close } from "@mui/icons-material";
import { API } from "../conf";
import { Context } from "../App";

export default function OffSpe(props) {
    const { updateConnect } = useContext(Context)
    const [open ,SetOpen] = useState(-1)
    const [newOff, setNew] = useState('')
    const [is_deptm, setDeptm] = useState(false)

    function handleSelectLabel(e, index) {
        if (e === "0") {
            SetOpen(index)
        } else {
            props.setOffSpe(old => old.slice(0, index).concat([{libelle: e.libelle, montant:old[index].montant, compte: e.num}].concat(old.slice(index+1))))
            SetOpen(-1); setNew('')
        }
    }

    function handleSubmit() {
        fetch(API.concat(`/comptes/create`), {method: 'POST', headers:{
            Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, 
            body: JSON.stringify({libelle: newOff, is_offrande: true, is_departement: is_deptm, is_hors_budget: true, eglise: props.eglise._id})
        }).then(async(response)=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            } else if (token && token !== sessionStorage.getItem('token') && token !== '') {
                sessionStorage.setItem('token', response.headers.get('x-auth-token'))
            }
            if (response.status === 200){
                const compte = await response.json()
                props.setOffSpeLabel(old => {old.unshift({libelle: compte.libelle, num:compte.num}); return old})
                handleSelectLabel({libelle: compte.libelle, num:compte.num}, open)
            }
        })
    }

    return(
        <Box>
            {props.offSpe.map((offrande, index) =>
            <Grid container key={index} columnSpacing={1} sx={{marginBottom:'10px'}}>
                {props.offSpe.length>1 && <Grid item sm={1}>
                    <IconButton 
                    aria-label="supprimer"
                    sx={{padding:0}} 
                    onClick={()=>{
                        props.setTotal(old => old-props.offSpe[index].montant)
                        props.setOffSpe(old => old.slice(0, index).concat(old.slice(index+1)))
                    }}>
                        <Close/>
                    </IconButton>
                </Grid>}
                <Grid item sm={6.5}>
                    <TextField
                    fullWidth
                    select
                    label={props.label}
                    value={offrande.compte}
                    onChange={(event)=> {
                        const e = event.target.value==="0" ? "0" : props.offSpeLabel.find(off => off.num===event.target.value)
                        handleSelectLabel(e, index)
                    }}
                    >
                        {props.offSpeLabel.map((label, index) => (
                            <MenuItem key={index} value={label.num} disabled={props.offSpe.filter(off=> off.libelle === label.libelle).length>0}>
                                <Typography sx={{textTransform:'capitalize'}}>{label.libelle}</Typography> 
                            </MenuItem>
                        ))}
                        {props.canAdd && <MenuItem key={index} value={"0"}>
                            <Typography sx={{fontWeight:'bold'}}>Ajouter</Typography> 
                        </MenuItem>}
                    </TextField>
                </Grid>
                <Grid item sm={3}>
                    <TextField
                    fullWidth
                    label="Montant(en €)"
                    InputLabelProps={{shrink: true}}
                    inputProps={{step:"0.01", min:'0'}}
                    type="number"
                    value={offrande.montant.toFixed(2)}
                    onChange={(e)=>{if(!isNaN(Number(e.target.value))){
                        props.setTotal(old => Number((old-props.offSpe[index].montant+Number(e.target.value)).toFixed(2)))
                        props.setOffSpe(old => old.slice(0, index).concat([{libelle: old[index].libelle, montant:Number(Number(e.target.value).toFixed(2)), compte: old[index].compte}].concat(old.slice(index+1))))
                    }}}
                    />
                </Grid>
                {index === props.offSpe.length-1 && offrande.libelle!=='' && offrande.montant>0 && (props.offSpeLabel.length>props.offSpe.length || props.canAdd) &&
                <Grid item sm={1.5}>
                    <Button aria-label="ajouter une offrande spécifiée" 
                    variant="contained" 
                    color="primary" 
                    fullWidth
                    sx={{paddingX:0, width:'100%'}}
                    onClick={()=> props.setOffSpe(old => old.concat([{libelle: '', montant:0, compte:''}]))}>
                        <Add sx={{margin:0}}/>
                    </Button>
                </Grid>}
            </Grid>)}
            <Dialog open={open>-1} onClose={()=>{setNew(''); SetOpen(-1)}}>
                <DialogTitle>Ajouter une nouvelle Offrande spécifiée</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="normal"
                        label="Libellé"
                        fullWidth
                        variant="standard"
                        value={newOff}
                        onChange={(e)=>setNew(e.target.value)}
                    />
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={is_deptm} onChange={()=>setDeptm(old=>!old)} />} label="département" />
                    </FormGroup>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{setNew(''); SetOpen(-1)}}>Annuler</Button>
                    <Button disabled={newOff.replaceAll(' ', '').length < 2 } onClick={handleSubmit}>Enregistrer</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}